import {
    Card,
    Flex, Input,
    List,
    Segmented,
    Space
} from "antd";
import React, {useCallback, useState} from "react";
import {aiChainPrompt} from "../../Prompt";
import {ModelsMenu} from "../../components/ModelsMenu";
import {LanguagesGroup} from "../../components/LanguagesGroup";
import {GenButton} from "../../components/GenButton";
import {generateTranslationPrompt} from "../ToolsPrompts";

export const Translator = (props: {
    text?: string,
    onItemClick?: (item: any) => void
}) => {
    const [languages, setLanguages] = useState(["Russian"]);
    const [names, setNames] = useState([]);
    const [language, setLanguage] = useState(languages[0]);
    const [switchLangs, setSwitchLangs] = useState<string[]>([]);
    const [height, setHeight] = useState(0);
    const [text, setText] = useState(props.text || '');

    const elementRef = useCallback((node: any) => {
        if (!node) return;
        const resizeObserver = new ResizeObserver(() => {
            setHeight(node.getBoundingClientRect().height);
        });
        resizeObserver.observe(node);
    }, []);

    return (
        <Flex gap={16} style={{width: "100%"}}>
            <Flex vertical={true} gap={10} style={{height: "100%", width: 300}} ref={elementRef}>
                <ModelsMenu/>
                <Card title={"Text"}>
                    <Input value={text} onChange={(e) => setText(e.target.value)}/>
                </Card>
                <Card title={"Languages"}>
                    <LanguagesGroup
                        languages={languages}
                        onChange={setLanguages}
                    />
                </Card>
                <GenButton
                    style={{width: "100%"}}
                    type={'primary'}
                    actions={[{
                        key: "1",
                        title: "Generate",
                        action: async (model: string, projectId: string) =>
                            aiChainPrompt({
                                projectId: projectId ?? '',
                                prompt: generateTranslationPrompt(
                                    {
                                        text: text,
                                        translations: languages
                                    }
                                ),
                                model: model,
                                type: "json"
                            }).then((response) => {
                                setNames(response.data)
                                setSwitchLangs(languages)
                                setLanguage(languages[0])
                            }).catch((e) => {
                                console.log(e)
                            })
                    }]}/>
            </Flex>
            <Flex vertical={true} gap={16} style={{flexGrow: 1}}>
                <Segmented
                    options={
                        switchLangs.map((lang) => ({
                            value: lang,
                            label: lang
                        }))
                    }
                    value={language}
                    onChange={(value) => {
                        setLanguage(value)
                    }}/>
                <List
                    style={{
                        width: "100%",
                        height: `calc(${height}px - 48px)`,
                        overflowY: 'auto',
                        scrollbarWidth: "none",
                        cursor: 'pointer'
                    }}
                    dataSource={names}
                    renderItem={(item: any, index) =>
                        <List.Item onClick={() => props.onItemClick?.(item)}>{index + 1}. {item[language]}</List.Item>}
                />
            </Flex>
        </Flex>
    );
}